"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Anchor = require("./Anchor");

var _Anchor2 = _interopRequireDefault(_Anchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Anchor2.default;